
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApiService } from 'src/app/shared/services/api.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
// import { ExportService } from '../shared/services/exportservice';
import { ExportService } from '../shared/services/exportserviceforprocess';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-process-results-list',
  standalone: true,
  imports: [
    FormsModule,
    MatTableModule,
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatPaginatorModule
  ],
  templateUrl: './process-results-list.component.html',
  styleUrl: './process-results-list.component.scss'
})
export class ProcessResultsListComponent {
  months: any;
  years: any;
  pageSize = 10;
  exam_month: any;
  exam_year: any;
  result_type: any;
  courseList: any[] = [];
  semesterList: any[] = [];
  searchText: string = '';
  processed_results:any;
  paginatedStudents:any;
  subject_list:any;
  result_table_list:any;
  tableHeaderLength=10;
  sem_roman_number:any;
  isExcelReportview:any;
  course_code:any;
  course_name:any;
  iti_data: any

  isA3Reportview:boolean=false;

  selectedCourseId: string = '';
  selectedSemester: string = '';
  section:string='';
  course_subjects:any
  //selectedSemesterNumber: number | null = null;
  results: any[] = [];
  isCumulativeProcessed:boolean=false;
  displayedColumns: string[] = [];
  displayedColumns_for_results: string[] = []
  displaycolumns_for_subjects = ['subject_name']
  displayedColumns_for_processed_results =  [
    'subject','name','register_no','ia_sub1','see_sub1','result_sub1','grade_sub1',
    'ia_sub2','see_sub2','result_sub2','grade_sub2',
    'ia_sub2','see_sub2','result_sub2','grade_sub2',
    'ia_sub3','see_sub3','result_sub3','grade_sub3',
    'ia_sub4','see_sub4','result_sub4','grade_sub4',
    'ia_sub5','see_sub5','result_sub5','grade_sub5',
    'ia_sub6','see_sub6','result_sub6','grade_sub6',
    'ia_sub7','see_sub7','result_sub7','grade_sub7',
    'ia_sub8','see_sub8','result_sub8','grade_sub8',
    'total_earned_credits','weighted_grade_points','cumulative_credits_earned',
    'sgpa','cgpa','total_percentage','overall_result'
  ]
  pagination = {
    length: 0,
    page: 1,
    limit: 10,
  }
  currentPage = 0;
  subjects:any;

  constructor(private api: ApiService ,private exportService: ExportService,private common:CommonService ) { }

  ngOnInit(): void {
    this.year_list();
    this.month_list();
    this.isA3Reportview=false;
    this.api.get('courses/list').subscribe(res => {
      if (res.success) this.courseList = res.data;
    });

    this.api.get('semesters/list').subscribe(res => {
      if (res.success) this.semesterList = res.data;
    });
  }

  onFiltersChange(search?: string): void {
    if (this.selectedCourseId && this.selectedSemester !== null) {
      const queryParam: any = [];
      queryParam.push(`course_id=${this.selectedCourseId}&semester_number=${this.selectedSemester}`);
      queryParam.push(`result_type=${this.result_type}`);
      queryParam.push(`exam_month=${this.exam_month}`, `exam_year=${this.exam_year}`);
      queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);

      if (search) {
        queryParam.push(`search=${search}`);
      }
 this.isA3Reportview=false;
      this.api.get(`results/processed/list?${queryParam.join('&')}`)
        .subscribe((res: any) => {
          this.results = res.status ? res.data : [];
          // Dynamically get keys from the first record
          if (this.results.length > 0) {
            const excludedFields = ['id', 'student_id', 'course_id'];
            this.pagination.length = res.totalCount || 0;
            // Collect all unique keys from all rows
            const allKeys = new Set<string>();
            this.results.forEach((row: any) => {
              Object.keys(row).forEach(key => {
                if (typeof row[key] !== 'object' && !excludedFields.includes(key)) {
                  allKeys.add(key);
                }
              });
            });
            this.displayedColumns = Array.from(allKeys);
          }
        });
    }
  }


  applyFilter() {
    this.pagination.page = 1;
    this.onFiltersChange(this.searchText);
  }

  pageEvent(e: any) {
    this.pagination.page = e.pageIndex + 1;
    this.pagination.limit = e.pageSize;
    this.currentPage = e.pageIndex * e.pageSize;
    this.onFiltersChange();
  }

  year_list() {
    this.api.get('settings/year_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.years = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  month_list() {
    this.api.get('settings/month_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  get_all_the_students_exel_data(courseId?: any, semester_num?: string, result_type?: any, exam_month?: any, exam_year?: any) {
  const payload = {
    course_id: courseId,
    semester_number: semester_num,
    result_type,
    exam_month,
    exam_year
  };

  this.api.post('results/getProcessedResults_for_exel_export', payload, true).subscribe({
    next: (resp) => {
      if (resp.status) {
        // this.subjects = resp.subjects;
        this.processed_results = resp.data;
        this.course_subjects = resp.subject;
        this.paginatedStudents = this.chunkArray(this.processed_results, 10);
       //this.tableHeaderLength=this.tableHeaderLength+this.course_subjects.length;
        const subjectMetaHeaders = ['Name of the Candidate', 'Sl No   Register No', 'IA Max Marks', 'IA Min Marks','End Exam Max', 'End Exam Min', 'Total Max Marks', 'Total Min Marks','Credits'];

const subject_metadata_rows: any[][] = [];

const maxSubjects = 8;
const actualSubjects = this.course_subjects.length;

const fieldMap: { [key: string]: string } = {
  'IA Max Marks': 'cie_max',
  'IA Min Marks':'cie_pass',
  'End Exam Max':'see_max', 
  'End Exam Min':'see_pass', 
  'Total Max Marks':'subject_max', 
  'Total Min Marks':'subject_min',
  'Credits':'credits'
 
};
subjectMetaHeaders.forEach((field) => {
  const row: any[] = ['', '']; // first two columns for spacing

  for (let i = 0; i < actualSubjects; i++) {
    const sub = this.course_subjects[i];
    const actualField = fieldMap[field]; // map display name to actual property
    const value = sub?.[actualField] ?? '';
    // const sub = this.course_subjects[i];
    // const value = sub?.[field] ?? '--';
    row.push(value);
    row.push('');
  }

  subject_metadata_rows.push(row);
});
        const req = {
            displayedColumns: this.displayedColumns_for_processed_results,
            data: this.processed_results,
            filename: 'result_list',
            dateField: ['dob'], // or any date fields if needed

            subject_metadata_rows,
            subjectCount: actualSubjects,
            semester: this.selectedSemester,
            month:this.exam_month,
            year:exam_year
          };
          
          this.exportService.exportExcel(req);
      } else {
        console.warn('API responded with status false:', resp.message);
      }
    },
    error: (err) => {
      console.error('Error fetching student Excel data:', err);
    }
  });
}



updateProcessedStats(courseId?: any, semester_num?: string, result_type?: any, exam_month?: any, exam_year?: any)
{

   const payload = {
    course_id: courseId,
    semester_number: semester_num,
    result_type,
    exam_month,
    exam_year
  };
this.api.post('results/semwise_cumulative', payload, true).subscribe(response => {
  if (response.status) {
    this.isCumulativeProcessed=true;
   this.common.notification(response.message);
  }else{
    this.common.notification(response.message);
  }
});
}


onCourseChange(courseId: number): void {
 this.isCumulativeProcessed=false;
}


printA3() {
  const printContents = document.getElementById('printSection')?.innerHTML;
  const styles = `
    <style>
      body {
        font-family: "Times New Roman", Times, serif;
        font-size: 15px;
        margin: 0;
        padding: 0;
      }
.a3-sheet {
    page-break-after: always;
    position: relative;
  }
 

/* Add extra space at the right of the table */
.table-wrapper {
  overflow-x: auto;
  margin-right: 50px; /* space for manual remarks */
  position: relative;
}

/* Optional: an empty cell for remarks (if applicable) */
.remarks-space {
  width: 50px;
  border: none;
}


.table-wrapper {
  padding-right: 50px;
}
  .student-reg {
  text-align: left !important;
  padding-left: 25px !important;
}

  .page-footer {
    text-align: right !important;
    bottom:10px !important;
  }
  .result-view{
    text-align: left !important;
  }

      h2, h3, h4, h5 {
        text-align: center;
        margin: 4px 0;
      }
//table headers
.result-table {
  width: 100%;
  border-collapse: separate !important;
  border-spacing: 2px 4px !important;
  font-size:15px;
  font-weight:bold;
}

.result-table th,
.result-table td {
  padding: 2px 4px !important;
  line-height: 1.1;
  font-size: 15px;
  text-align: left;
  vertical-align: top;
   font-weight:bold;
}

.static-header {
  padding-left: 30px !important;
  font-size:15px;
  white-space: nowrap;
  text-align: left;
}
/* ✅ First header and first column only */
.result-table th:first-child,
.result-table td:first-child {
  padding-left: 80px !important;
  white-space: nowrap;
}
.verticalLetters {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: left !important;
  vertical-align: top !important;
  font-size:15px;
  padding: 1px 2px !important;
  white-space: nowrap;
}

.bottom-text {
  text-align: left !important;
  vertical-align: bottom !important;
  padding: 0 2px !important;
  font-size:15px;
  line-height: 1.1;
}
  .result-table td.bottom-texts  {
  text-align: center !important;
  }

.line-separator {
        border:1px solid black;
          }

 .signatures {
    display: flex !important;
    flex-direction: row !important; /* <-- Add this line */
    justify-content: space-between !important;
    align-items: flex-start !important;
    width: 100% !important;
    gap: 20px !important; /* optional spacing */
    padding: 0 40px !important;
  }

  .signatures .left,
  .signatures .right {
    width: 100% !important;  
    display: block !important;
  }
.signatures .left{
padding-left: 80px !important;
}

.top-header-container {
  margin-bottom: 15px;
}

.top-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 0 30px;
}

.programme-top-left,
.programme-top-right {
  font-size:15px;
  font-weight: bold;
  white-space: nowrap;
}
  .programme-top-left{
  padding-left: 70px !important;
  }

.header-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
 .sub-dict {
  font-weight: bold;
  color: black;
  font-size: 15px;
  padding-left: 80px !important; /* increased to 80px */
}

.header-center h2 {
  margin: 0;
  font-size: 15px;
  font-weight: bold;
}

.header-below {
  text-align: center;
}

.header-below h3,
.header-below h4 {
  margin: 2px 0;
}

.footer {
  margin-top: 40px;

}
  .print-divider-cell {
    border-bottom: 2px solid black !important;
    height: 2px;
    padding: 0;
  }

  .print-divider-row {
    height: 2px;
  }


  .double-vertical {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 4px; /* space between the two lines */
  vertical-align:bottom !important;
  text-align: start;
  padding: 0;
}

      @page {
        size: A3 landscape;
        margin: 10mm;
      }
    </style>
  `;

  const popupWin = window.open('', '_blank', 'width=1200,height=800');
  if (popupWin && printContents) {
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>A3 Result Sheet</title>
          ${styles}
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);
    popupWin.document.close();
  }
}
sem_no:any;
month:any;
year:any;
division:any;
isRegular_for_a3:boolean=true;
getA3ReportDetails(courseId?: any, semester_num?: string, result_type?: any, exam_month?: any, exam_year?: any,section?:any){
 
  
  if(result_type==="regular")
  {
     this.isRegular_for_a3=true;
  }else
  {
   this.isRegular_for_a3=false; 
  }
  this.isExcelReportview=false;
  this.sem_no=semester_num;
  this.month=exam_month;
  this.year=exam_year;                   
  const foundItem = this.courseList.find(item => item.id ===courseId );

if (foundItem) {
  const { crs_code, name } = foundItem;
  this.course_code=crs_code;
  this.course_name=name;
}
if(section==='SEC0')
{
  this.division='I';
}else
{
  this.division='II';
}

                    if (semester_num == "1") { this.sem_roman_number = "I"; }
                    if (semester_num == "2") { this.sem_roman_number = "II"; }
                    if (semester_num == "3") { this.sem_roman_number = "III"; }
                    if (semester_num == "4") { this.sem_roman_number = "IV"; }
                    if (semester_num == "5") { this.sem_roman_number = "V"; }
                    if (semester_num == "6") { this.sem_roman_number = "VI"; }
  const payload = {
    course_id: courseId,
    semester_number: semester_num,
    result_type,
    exam_month,
    exam_year,
    section,
  };
  this.isA3Reportview=true;
  this.api.post('results/getProcessedResults_for_exel_export', payload, true).subscribe({
    next: (resp) => {
      if (resp.status) {
        // this.subjects = resp.subjects;
        this.processed_results = resp.data;
        this.course_subjects = resp.subject;
        this.tableHeaderLength=this.tableHeaderLength+this.course_subjects.length;
        this.paginatedStudents = this.chunkArray(this.processed_results, 10);
        this.iti_data = resp.iti_grand_totle
      }
    }
  });
}



chunkArray(arr: any[], chunkSize: number): any[][] {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
}

exportExcel() {
  this.isExcelReportview=true;
  const data = this.generateExcelData();
  const worksheet = XLSX.utils.aoa_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'ResultSheet');
  XLSX.writeFile(workbook, `A3_Marksheet_Sem${this.sem_no}.xlsx`);
}


generateExcelData() {
  const rows: any[][] = [];
  
  this.paginatedStudents.forEach((studentGroup, pageIndex) => {
    // Add Header block (repeated per page)
    rows.push([
      'GOVERNMENT OF KARNATAKA',
      '',
      '',
      'DEPARTMENT OF COLLEGIATE AND TECHNICAL EDUCATION'
    ]);
    rows.push([
      '',
      '',
      '',
      'BOARD OF TECHNICAL EXAMINATIONS, BENGALURU'
    ]);
    rows.push([
      '',
      '',
      '',
      'B.V.V.S. POLYTECHNIC (AUTONOMOUS), BAGALKOT'
    ]);
    rows.push([
      '',
      '',
      '',
      `PROVISIONAL MARKS SHEET - THIRD SEMESTER EXAMINATION - NOV 2024`
    ]);
    rows.push(['']); // spacer

    // Add column headers
    const subjectHeaders = this.course_subjects.flatMap((_, i) => [`Sub 0${i+1}`, 'Grade']);
    const staticHeaders = [
      'CREDITS EARNED',
      'TOTAL CREDIT POINTS EARNED',
      'CUMULATIVE CREDIT EARNED',
      'SGPA',
      'CGPA',
      'PERCENTAGE',
      'RESULT'
    ];
    rows.push([
      'Name / Reg No',
      ...subjectHeaders,
      ...staticHeaders
    ]);

    // Add student rows
    studentGroup.forEach((student, i) => {
      const subjectResults = [];

      for (let s = 1; s <= this.course_subjects.length; s++) {
        subjectResults.push(
          `${student[`ia_sub${s}`] ?? ''}\n${student[`see_sub${s}`] ?? ''}\n${student[`result_sub${s}`] ?? ''}`,
          `${student[`grade_sub${s}`] ?? ''}`
        );
      }

      rows.push([
        `${i + 1}. ${student.name}\n${student.register_no}`,
        ...subjectResults,
        student.total_earned_credits,
        student.weighted_grade_points,
        student.cumulative_credits_earned,
        student.sgpa,
        student.cgpa === 'Credit(s) Pending' ? 'Pending' : student.cgpa,
        student.total_percentage,
        student.overall_result
      ]);
    });

    // Add subject legends (e.g., 01 SUBJECT NAME)
    const legendRow = this.course_subjects.map((s, i) => `0${i + 1}: ${s.subject_name}`);
    rows.push(['', ...legendRow]);

    // Page footer
    rows.push([`Page ${pageIndex + 1}`]);

    // Only add spacing (fake page break) if not last page
    if (pageIndex < this.paginatedStudents.length - 1) {
      rows.push([]);
      rows.push([]);
    }
  });

  // Add final footer at end
  rows.push([]);
  rows.push(['Controller of Examinations', '', '', 'Chairman and Principal']);

  return rows;
}
getGrandTotalCieMax(): number {
  return this.course_subjects?.reduce((total:any, subject) => {
    const cie = +subject.cie_max;
    return total + (isNaN(cie) ? 0 : cie);
  }, 0) || 0;
}



}
